module.exports = __webpack_public_path__ + "static/media/eccomerce-web.92f334ff.svg";